'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  text-align: ', ';\n\n  > * {\n    margin-top: 5px;\n  }\n'], ['\n  text-align: ', ';\n\n  > * {\n    margin-top: 5px;\n  }\n']);

exports.default = FieldValidations;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var _reactEmotion = require('react-emotion');

var _reactEmotion2 = _interopRequireDefault(_reactEmotion);

var _fieldValidation = require('../field-validation');

var _fieldValidation2 = _interopRequireDefault(_fieldValidation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledFieldValidation = /*#__PURE__*/(0, _reactEmotion2.default)('div')(_templateObject, function (props) {
  return props.centered ? 'center' : 'left';
});

function FieldValidations(props) {
  var validations = props.validations,
      centered = props.centered;


  return _react2.default.createElement(
    StyledFieldValidation,
    { centered: centered },
    validations ? validations.map(function (validation) {
      return (
        // $FlowFixMe
        _react2.default.createElement(_fieldValidation2.default, { validation: validation, key: validation.message })
      );
    }) : null
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/field-validations/field-validations.js
// module id = 318
// module chunks = 114276838955818